import dayjs from "dayjs"

const monthNameToIndex = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
}

export default function checkBoardReviewPeriod(reviewPeriods) {
  //we are checking if we are within any review period for a board
  const currentMonth = dayjs().month()
  const activeReviewPeriods = reviewPeriods?.filter((period) => {
    // compute month indexes from names to avoid relying on SQL-computed values
    const start =
      monthNameToIndex[period.review_period_start?.toLowerCase()] ?? null
    const end =
      monthNameToIndex[period.review_period_end?.toLowerCase()] ?? null
    if (start == null || end == null) {
      return false
    }
    if (start > end) {
      // Wraparound case (e.g., Dec–Feb): use OR logic
      return currentMonth >= start || currentMonth <= end
    }
    return currentMonth >= start && currentMonth <= end
  })

  return activeReviewPeriods?.length > 0
}
